import { useState } from 'react';
import { SimplePageLayout, PlatformLoader } from '@flexinet/ui-components';
import { Stack, Select, Group, Button } from '@mantine/core';
import { MdRefresh } from 'react-icons/md';
import { useAnalytics } from '../hooks/useAnalytics';
import { EmailsOverTimeChart } from '../components/EmailsOverTimeChart';
import { AliasActivityChart } from '../components/AliasActivityChart';
import { TagUsageChart } from '../components/TagUsageChart';
import { StatsCards } from '../components/StatsCards';
import { useQueryClient } from '@tanstack/react-query';

export const AnalyticsDashboardPage = () => {
    const [dateRange, setDateRange] = useState<string>('30');
    const { data, loading } = useAnalytics(parseInt(dateRange));
    const queryClient = useQueryClient();

    const handleRefresh = () => {
        queryClient.invalidateQueries({ queryKey: ['messages'] });
    };

    if (loading) {
        return <PlatformLoader message="Loading analytics..." />;
    }

    return (
        <SimplePageLayout
            pageHeader={
                <Group justify="space-between" p="md">
                    <h2>Analytics Dashboard</h2>
                    <Group>
                        <Select
                            value={dateRange}
                            onChange={(value) => setDateRange(value || '30')}
                            data={[
                                { value: '7', label: 'Last 7 days' },
                                { value: '30', label: 'Last 30 days' },
                                { value: '90', label: 'Last 90 days' },
                                { value: '120', label: 'Last 120 days' }
                            ]}
                            w={150}
                        />
                        <Button leftSection={<MdRefresh />} onClick={handleRefresh}>
                            Refresh
                        </Button>
                    </Group>
                </Group>
            }
        >
            <Stack gap="xl" p="md">
                <StatsCards
                    totalMessages={data.totalMessages}
                    totalSent={data.totalSent}
                    totalReceived={data.totalReceived}
                />
                <EmailsOverTimeChart data={data.emailsByDate} />
                <AliasActivityChart data={data.aliasActivity} />
                {data.tagUsage.length > 0 && <TagUsageChart data={data.tagUsage} />}
            </Stack>
        </SimplePageLayout>
    );
};
